export default __webpack_public_path__ + "logo74fdc4f.png";